export class FHLog {
    constructor() {
        this.log = (...args) => {
            console.log(args);
        };
        this.error = (...args) => {
            console.error(args);
        };
        this.trace = (...args) => { };
    }
    quiet() {
        FHLog.fhLog.log = () => {
        };
        FHLog.fhLog.error = () => {
        };
        FHLog.fhLog.trace = () => {
        };
    }
    Замолчи() {
        this.quiet();
    }
}
FHLog.fhLog = new FHLog();
export const fhLog = FHLog.fhLog;
//# sourceMappingURL=feature_hub_config.js.map